import { RouteFactory } from "@app/routePaths";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";

/**
 * Component to render Nominations Description of SBA on homepage
 */
const SBANominationsDescription = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <div
      className="flex w-full flex-row items-center justify-center text-center md:px-0 lg:mx-auto lg:w-10/12"
      data-testid="sba-nominations-description-component"
    >
      <IconFactory
        type={IconTypeEnum.apply}
        x={80}
        y={60}
        size={isScreenLG ? 105 : 80}
        className="mr-auto lg:mr-12"
      />

      <div className="flex-col items-center justify-center text-center font-public-sans text-gray-850 md:mr-20 lg:mr-11">
        <h2 className="text-center align-middle font-poppins text-4xl font-medium md:text-6xl lg:text-8xl lg:leading-tight">
          {"Nominations for "}
          <br className="inline lg:hidden" />
          {"the "}
          <strong>Singapore Business </strong>
          <br className="inline lg:hidden" />
          <strong>Awards 2026</strong> are now open
        </h2>

        <p className="my-2 text-lg font-semibold">
          Please submit all nominations by <strong>15 December 2025.</strong>
        </p>

        <p className="text-xs">
          Find out more{" "}
          <a
            href={RouteFactory.sbaNominatePage}
            target="_blank"
            className="text-blue-175"
            rel="noreferrer"
          >
            here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default SBANominationsDescription;
